import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './CallerTypePanel.css';
import { enums, openWindowWithPost } from '../../../utils';
import config from '../../../utils/env-config/env-config.json';
import dayjs from 'dayjs';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import InfoIcon from '../../../images/info-icon.svg';

const commonBtnClasses = "rounded-full text-white py-2 px-4 font-bold text-base w-[fit-content] text-center ml-4 md:ml-0 bg-[#0066B1]";
const commonFlexClasses = 'flex flex-col md:flex-row justify-between mr-2 gap-1';
const envConfig = config[window.location.hostname];

const EvaLink = p => {
  
  const state = {
    customerNumber: p.contactAttributes?.customerNumber?.value || '',
    dateOfBirth: p.contactAttributes?.plainTextDob?.value || '',
    employeeId: '',
    firstName: p.contactAttributes?.firstName?.value || '',
    lastName: p.contactAttributes?.lastName?.value || '',
    taxId: '',
  };

  state.dateOfBirth &&= dayjs(state.dateOfBirth).format('YYYY-MM-DD');

  return ( 
    <button className={`${commonBtnClasses} h-[fit-content]`} onClick={() => {
      openWindowWithPost(
        `${envConfig.suiBaseUrl}/web-apis/navigation-requests`,
        {
          appId: 'AGENTPORTAL',
          path: '/employee-validation-assistant',
          state: JSON.stringify(state),
        },
      );
    }}>
      Employee Validation Assistant
    </button>
  );
}

const TasksLink = (p) => {
  const customerNumber = p.customerNumber || undefined;
  const hasTasks = p.hasTasks || false;

  const path = customerNumber
    ? `${enums.AppPaths.taskList}?id=${customerNumber}`
    : enums.AppPaths.tasks;
  const text = customerNumber ? `Tasks for ${customerNumber}` : 'Tasks';
  
  return ( 
    <Link to={path} target="_blank">
      <div className={`${commonBtnClasses} ${hasTasks === true ? 'bg-[#CC232F]' :''}`}>
        {text}
      </div>
    </Link>
  );
};

const renderLinks = (p) => (
  <div className={commonFlexClasses.replace('md:flex-row', 'items-end')}>
    <TasksLink 
      customerNumber={p?.contactAttributes?.customerNumber?.value} 
      hasTasks={p?.contactAttributes?.hasTasks?.value} 
    />
    <EvaLink contactAttributes={p.contactAttributes} />
  </div>
);


const CallerTypePanel = (props) => {
  const [open, setOpen] = React.useState(false);

  const handleToClose = (event, reason) => {
    if ('clickaway' === reason) return;
    setOpen(false);
  };

  const handleClickEvent = () => {
    setOpen(true);
  };

  const [contactAttributes, setContactAttributes] = useState({});
  useEffect(() => {
    if (props.contactAttributes) {
      setContactAttributes(props.contactAttributes);
    }
  }, [props]);

  const renderCallerContent = () => {
    if (contactAttributes.callerType?.value === 'Claimant') {
      return (
        <div>
          {contactAttributes?.queuedCallback?.value === 'true' ?
          <Box 
            sx={{
              background: '#EFF3F8',
              borderRadius: '4px',
              marginLeft: '4%',
              marginRight: '4%',
              marginBottom: '4%',
            }}>
              <div className="flex flex-row p-1 pl-4">
              <img src={InfoIcon} alt="" />
              <p className="font-['Open_Sans'] font-normal text-base ml-1">This is an outbound callback</p>
            </div>
          </Box> : null}
          <div className={commonFlexClasses}>
            <div>
              <p className="callerType fs-unmask">
                {contactAttributes.callerType
                  ? contactAttributes.callerType.value
                  : ''}
              </p>
              <p className="callerName">
                {contactAttributes.firstName
                  ? contactAttributes.firstName.value +
                    ' ' +
                    contactAttributes.lastName.value
                  : ''}
                  <ContentCopyIcon
                  sx={{
                    position: 'relative',
                    left: '5px',
                    ":hover": {
                      bgcolor: "white",
                      color: "#1976d2",
                      scale: "1.3"
                    }
                  }}
                  className="copyIcon"
                  style={{ width: '15px', height: '15px' }}
                  onClick={() => {
                    navigator.clipboard.writeText(
                      contactAttributes.firstName.value + 
                      ' ' +
                      contactAttributes.lastName.value
                      );
                      handleClickEvent();
                    }}
                    >
                    </ContentCopyIcon>
                    <Snackbar
                      anchorOrigin={{
                        horizontal: 'left',
                        vertical: 'bottom',
                      }}
                      open={open}
                      autoHideDuration={5000}
                      message="Copied."
                      onClose={handleToClose}
                      action={
                          <IconButton
                            size="small"
                            aria-label="close"
                            color="inherit"
                            onClick={handleToClose}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                      }
                          />
              </p>
            </div>
            {renderLinks(props)}
          </div>
      </div>
      );
    }

    if (contactAttributes.chatTopic) {
      return (
        <div className={commonFlexClasses}>
          <div>
            <p className="callerType fs-unmask">EMPLOYEE</p>
            
            <p className="callerName">
              {contactAttributes.firstName
                ? contactAttributes.firstName.value +
                  ' ' +
                  contactAttributes.lastName.value
                : ''}
                <ContentCopyIcon
                sx={{
                  position: 'relative',
                  left: '5px',
                  ":hover": {
                    bgcolor: "white",
                    color: "#1976d2",
                    scale: "1.3"
                  }
                }}
                className="copyIcon"
                style={{ width: '15px', height: '15px' }}
                onClick={() => {
                  navigator.clipboard.writeText(
                    contactAttributes.firstName.value + 
                    ' ' +
                    contactAttributes.lastName.value
                    );
                    handleClickEvent();
                  }}
                  ></ContentCopyIcon>
              <Snackbar
                            anchorOrigin={{
                              horizontal: 'left',
                              vertical: 'bottom',
                            }}
                            open={open}
                            autoHideDuration={5000}
                            message="Copied."
                            onClose={handleToClose}
                            action={
                              <IconButton
                                size="small"
                                aria-label="close"
                                color="inherit"
                                onClick={handleToClose}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            }
                          />
            </p>
          </div>
          {renderLinks(props)}
        </div>
      );
    }

    return (
      <div>
        {contactAttributes?.queuedCallback?.value === 'true' ?
          <Box 
            sx={{
              background: '#EFF3F8',
              borderRadius: '4px',
              marginLeft: '4%',
              marginRight: '4%',
              marginBottom: '4%',
            }}>
              <div className="flex flex-row p-1 pl-4">
              <img src={InfoIcon} alt="" />
              <p className="font-['Open_Sans'] font-normal text-base ml-1">This is an outbound callback</p>
            </div>
          </Box> : null}
        <div className={commonFlexClasses}>
          <div>
            <p className="callerType fs-unmask">
              {contactAttributes.callerType
                ? contactAttributes.callerType.value
                : ''}
            </p>
            <p className="callerName">
              {contactAttributes.callerType ? 'Name not available' : ''}
            </p>
            <p className="callerType fs-unmask">EMPLOYEE</p>
          
          <p className="callerName">
            {contactAttributes.firstName && 
              contactAttributes.lastName
              ? contactAttributes.firstName.value +
                ' ' +
                contactAttributes.lastName.value
              : ''}
              {contactAttributes.firstName && contactAttributes.lastName &&
               contactAttributes.firstName.value + contactAttributes.lastName.value !== '' ? (
              <ContentCopyIcon
              sx={{
                position: 'relative',
                left: '5px',
                ":hover": {
                  bgcolor: "white",
                  color: "#1976d2",
                  scale: "1.3"
                }
              }}
              className="copyIcon"
              style={{ width: '15px', height: '15px' }}
              onClick={() => {
                navigator.clipboard.writeText(
                  contactAttributes.firstName.value + 
                  ' ' +
                  contactAttributes.lastName.value
                  );
                  handleClickEvent();
                }}
                ></ContentCopyIcon>
                ) : (
                  ''
                )
                }
                <Snackbar
                  anchorOrigin={{
                    horizontal: 'left',
                    vertical: 'bottom',
                  }}
                  open={open}
                  autoHideDuration={5000}
                  message="Copied."
                  onClose={handleToClose}
                  action={
                    <IconButton
                      size="small"
                      aria-label="close"
                      color="inherit"
                      onClick={handleToClose}
                    >
                    <CloseIcon fontSize="small" />
                    </IconButton>
                  }
                      />                    
                </p>
          </div>
          {renderLinks(props)}
        </div>
          
      </div>
    );
  };

  return renderCallerContent();
};

CallerTypePanel.propTypes = {
  contactAttributes: PropTypes.shape({
    callerType: PropTypes.shape({
      value: PropTypes.string,
    }),
    queuedCallback: PropTypes.shape({
      value: PropTypes.string,
    }),
    firstName: PropTypes.shape({
      value: PropTypes.string,
    }),
    lastName: PropTypes.shape({
      value: PropTypes.string,
    }),
    chatTopic: PropTypes.shape({
      value: PropTypes.string,
    }),
    customerNumber: PropTypes.shape({
      value: PropTypes.string,
    }),
    hasTasks: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    }),
    dob: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
};

export default CallerTypePanel;
